import React from "react"
import { ImageProps } from "@chakra-ui/react"

import { Illustrations } from "@components/Image"
import Image from "@components/Image/Image"

type IllustrationKeys = keyof typeof Illustrations

export interface IllustrationProps extends ImageProps {
  name: IllustrationKeys
}

const IllustrationMap: Partial<Record<IllustrationKeys, ImageProps>> = {
  bundle: { w: "117px", h: "112px" },
  dandelion: { w: "144px", h: "98px" },
  spores: { w: "217px", h: "156px" },
  spores2: { w: "117px", h: "94px" },
  spores3: { w: "117px", h: "94px" },
}

const Illustration = ({ name, ...props }: IllustrationProps) => {
  const imageProps = IllustrationMap[name] || {}
  return imageProps ? <Image name={name} {...imageProps} {...props} /> : <></>
}

export default Illustration
